import Svg, { ClipPath, G, Path, Rect } from "react-native-svg";
import { GetProps } from "tamagui";

const SvgComponent = ({ color, ...props }: GetProps<typeof Svg>) => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <G clipPath="url(#clip0_1607_7501)">
      <Path
        d="M9 16.6973H15M9 16.6973V20C9 20.5523 9.44772 21 10 21H14C14.5523 21 15 20.5523 15 20V16.6973M9 16.6973C7.2066 15.6599 6 13.7208 6 11.5C6 8.18629 8.68629 5.5 12 5.5C15.3137 5.5 18 8.18629 18 11.5C18 13.7208 16.7934 15.6599 15 16.6973M12.0001 16.6973V12.5419C12.0001 12.5155 11.9879 12.4905 11.967 12.4743L9.42944 10.5M12 12.5L14.5706 10.5M12 1V3M23 12H21M3 12H1M19.7782 19.7782L18.364 18.364M5.63604 5.63604L4.22183 4.22183M4.22189 19.7783L5.63611 18.3641M18.364 5.63614L19.7782 4.22192M11.9187 23H12.0813C13.141 23 14 22.141 14 21.0814C14 21.0387 13.9654 21.0042 13.9228 21.0042H10.0772C10.0346 21.0042 10 21.0387 10 21.0814C10 22.141 10.859 23 11.9187 23Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <ClipPath id="clip0_1607_7501">
      <Rect width={24} height={24} fill="white" />
    </ClipPath>
  </Svg>
);
export default SvgComponent;
